import { Flex, FlexProps, Text } from '@chakra-ui/react';
import { FC } from 'react';

interface IModelDescriptionProps extends FlexProps {
  title: string;
  description: string;
}

export const ModelDescription: FC<IModelDescriptionProps> = ({ title, description }) => {
  return (
    <Flex flex={1} textAlign="center" flexDirection="column" alignItems="center">
      <Text fontFamily="heading" fontWeight="bold" mb={2}>
        {title}
      </Text>
      <Text>{description}</Text>
    </Flex>
  );
};
